(function () {
  if (window.__byteAvisAtcStepLock) return;
  window.__byteAvisAtcStepLock = true;

  var CONTAINER_ID = 'avpoptions-container__v2';
  var STEP_SELECTOR = '.apo-step-child';
  var ACTIVE_CLASS = 'apo-step-child-active';
  var SUBMIT_SELECTOR = 'form[action*="/cart/add"] [type="submit"][name="add"]';
  var PAYMENT_SELECTOR = 'form[action*="/cart/add"] .shopify-payment-button';
  var LOCKED_CLASS = 'byte-atc-step-locked';
  var LOCK_FLAG = 'byteStepLocked';
  var MAX_INIT_ATTEMPTS = 50;

  var container = null;
  var isLocked = false;

  function isOnLastStep() {
    var steps = container.querySelectorAll(STEP_SELECTOR);
    if (steps.length === 0) return true;

    return steps[steps.length - 1].classList.contains(ACTIVE_CLASS);
  }

  function lockButton(button) {
    if (button.disabled && button.dataset[LOCK_FLAG] !== 'true') return;

    button.dataset[LOCK_FLAG] = 'true';
    if (!button.disabled) button.disabled = true;
    if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
  }

  function unlockButton(button) {
    // Only release buttons this script disabled, so sold out / unavailable states stay intact.
    if (button.dataset[LOCK_FLAG] !== 'true') return;

    delete button.dataset[LOCK_FLAG];
    button.disabled = false;
    button.removeAttribute('aria-disabled');
  }

  function sync() {
    isLocked = !isOnLastStep();

    document.querySelectorAll(SUBMIT_SELECTOR).forEach(function (button) {
      isLocked ? lockButton(button) : unlockButton(button);
    });

    document.querySelectorAll(PAYMENT_SELECTOR).forEach(function (paymentButton) {
      paymentButton.classList.toggle(LOCKED_CLASS, isLocked);
      paymentButton.inert = isLocked;
    });
  }

  function handleSubmit(event) {
    if (!isLocked) return;

    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.action)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function start(root) {
    container = root;

    // Window capture runs before the document capture listener of byte-avis-cart-summary.
    window.addEventListener('submit', handleSubmit, true);

    new MutationObserver(sync).observe(container, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });

    // Avis and Dawn re-render or clone the add to cart button, so re-apply the lock on DOM changes.
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      new MutationObserver(sync).observe(form.parentElement || form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    });

    sync();
  }

  function init(attempt) {
    // Products without Avis steps never match and keep the default add to cart behaviour.
    var root = document.getElementById(CONTAINER_ID);
    if (root && root.querySelector(STEP_SELECTOR)) {
      start(root);
      return;
    }

    if (attempt < MAX_INIT_ATTEMPTS) {
      setTimeout(function () {
        init(attempt + 1);
      }, 400);
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', function () {
        init(0);
      })
    : init(0);
})();
